import { apiEndPoint } from 'config';
import { apiConstants } from '../constants';
import { authHeader, handleResponse } from 'helpers';
import { queryFilters, queryWhere } from '../helpers/util';

export const pricingService = {
  get,
  getAll,
  update
};

function get(pricing_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };


  if (pricing_id) {
    var url = apiConstants.getPricing.replace(':tariff_id', pricing_id)
    return fetch(url, requestOptions)
      .then(handleResponse);
  } else return undefined;

}

function getAll(limit = global.LIMIT, page = global.PAGE, filters = undefined, ) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getAllPricing;
  var queryfilters = queryFilters(limit, page);
  if (filters) queryfilters = queryfilters.concat('', queryWhere(filters));
  return fetch(`${url}${queryfilters}`, requestOptions)
    .then(handleResponse);
}

function update(pricing_id, updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };

  return fetch(`${apiEndPoint.apiUrl}/pricing/${pricing_id}`, requestOptions)
    .then(handleResponse);
}
